import api from './api'

export default {
  async listarCategorias(params = {}) {
    const paramsComEmpresa = { ...params, empresaId: 3 }
    // Rota padrão: lista apenas categorias ativas (usada no catálogo, detalhes, etc.)
    const response = await api.get('/categorias', { params: paramsComEmpresa })
    return response.data
  },

  async listarCategoriasComInativasPorEmpresa(empresaId = 3, params = {}) {
    const paramsComEmpresa = { ...params, empresaId }
    // Rota específica para tela de cadastro: traz ativas + inativas
    const response = await api.get(`/categorias/empresa/${empresaId}/todos`, {
      params: paramsComEmpresa
    })
    return response.data
  },

  async buscarCategoria(id) {
    const response = await api.get(`/categorias/${id}`, { params: { empresaId: 3 } })
    return response.data
  },

  async criarCategoria(data) {
    const dataComEmpresa = { ...data, empresaId: 3 }
    const response = await api.post('/categorias', dataComEmpresa)
    return response.data
  },

  async atualizarCategoria(id, data) {
    const dataComEmpresa = { ...data, empresaId: 3 }
    const response = await api.put(`/categorias/${id}`, dataComEmpresa)
    return response.data
  }
}

